import axios from "axios";
import fileDownload from "js-file-download";
import { EnvAccessType } from "./constants";

export const getDownloadUrl = (
  image: string,
  downloadFile: boolean,
  setDownloadUrl?: React.Dispatch<React.SetStateAction<string>>
) => {
  return new Promise<string>((resolve, reject) => {
    try {
      let downloadImageUrl = "";

      let API_BASE_UPLOAD_URL = "";
      let accessType = "";

      switch (process.env.React_App_access_type) {
        case EnvAccessType.PROD:
          API_BASE_UPLOAD_URL =
            process.env.REACT_APP_API_PROD_BASE_UPLOAD_URL ?? "";
          accessType = process.env.React_App_PROD_Backend_End_Point ?? "";
          break;

        case EnvAccessType.DEV:
          API_BASE_UPLOAD_URL = process.env.REACT_APP_API_BASE_UPLOAD_URL ?? "";
          accessType = process.env.React_App_UAT_Backend_End_Point ?? "";
          break;
      }

      const downloadBaseUrl = `${API_BASE_UPLOAD_URL}?file_name=${image}&access_type=${accessType}&op_type=DOWNLOAD`;
      try {
        axios
          .post(downloadBaseUrl, null, {
            headers: {
              "Content-Type":
                "application/x-www-form-urlencoded; charset=UTF-8;application/json",
            },
          })
          .then((response) => {
            axios
              .get(response.data, { responseType: "blob" })
              .then((fileData) => {
                const resultUrl = response.data.split("?")[0];
                const file_name =
                  resultUrl.split("/")[resultUrl.split("/").length - 1];

                if (downloadFile) {
                  resolve(response.data);

                  fileDownload(fileData.data, file_name.replace("%20", " "));
                }

                if (!downloadFile) {
                  downloadImageUrl = response.data;
                  resolve(downloadImageUrl);
                  setDownloadUrl?.(response.data);
                }
              })
              .catch((err) => {
                console.error(err.response?.data || err.message);
                reject((err as Error).message.toString());
              });
          })
          .catch((err) => {
            reject((err as Error).message.toString());
          });
      } catch (err) {
        console.error((err as Error).message);
        reject((err as Error).message.toString());
      }
    } catch (err) {
      console.error((err as Error).message);
    }
  });
};
